// Per-order capability token. The backend returns it once when the order is
// placed; the placing browser keeps it so a bare /order/<id> link alone can't
// reveal the order (registered-customer orders are auth-gated instead).
export const orderToken = {
  save: (id, tok) => { try { if (id && tok) localStorage.setItem(`ord_${id}`, tok); } catch { /* ignore */ } },
  get: (id) => { try { return localStorage.getItem(`ord_${id}`) || ""; } catch { return ""; } },
};
